export default [
    {
        value: "text",
        text: "Text",
    },
    {
        value: "number",
        text: "Number",
    },
    {
        value: "stt",
        text: "STT",
    },
    {
        value: "tts",
        text: "TTS",
    },
];
